// Kept in sync with packages/api/src/services/customerListMatchingRules/columnNames.ts; both run the same case list.
export const CUSTOMER_LIST_MAX_COLUMNS = 50;

/**
 * Names a CSV's first 50 columns from their raw header cells, as the platform upload and the agent's header inspection
 * both do (`customer-list-matching-rules`, "Name CSV columns from their headers"). Takes the cells as written, before
 * any parser renaming, so blank and repeated headers are named here.
 */
export const nameCsvColumns = (headerCells: string[]) =>
  headerCells.slice(0, CUSTOMER_LIST_MAX_COLUMNS).reduce<string[]>((names, cell, index) => {
    const cleaned = cleanHeaderCell(cell);
    const name = cleaned ? prefixNonAlphanumericStart(cleaned) : `column_${index + 1}`;
    return [...names, uniqueName(name, names)];
  }, []);

const cleanHeaderCell = (cell: string) =>
  cell
    .replace(/[^a-zA-Z0-9_\s-]/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');

const prefixNonAlphanumericStart = (name: string) => (/^[a-zA-Z0-9]/.test(name) ? name : `column_${name}`);

const uniqueName = (name: string, earlierNames: string[]) => {
  if (!earlierNames.includes(name)) return name;
  let suffix = 1;
  while (earlierNames.includes(`${name}_${suffix}`)) suffix++;
  return `${name}_${suffix}`;
};
